import React from "react";
import './Footer.css';

const Footer = () => {
  return (
    <div className="footer-container">
   <center>   <hr className="ftr-hr" /> </center>
      <div className="ftr-data">
     
     <center>   <div className="rights-res">
        © 2022 Puneet Kathuria. All rights reserved
        </div> </center>
       
      </div>
    </div>
  );
};

export default Footer;
